import {registerSW} from 'virtual:pwa-register'
import {HOUR_MS} from "@/lib/constants.ts";

type UpdateAvailableCallback = () => void

/**
 * Registers the service worker generated by vite-plugin-pwa and wires up
 * update detection. Call this once (e.g. from a top-level React component).
 *
 * Returns an `updateSW` function: call `updateSW(true)` to activate the
 * waiting service worker and reload the page with the new build.
 */
export function setupServiceWorker(onUpdateAvailable: UpdateAvailableCallback) {
    return registerSW({
        immediate: true,

        // Fired once a new service worker (i.e. a new build) has been
        // downloaded and is waiting to take over.
        onNeedRefresh() {
            onUpdateAvailable()
        },

        onOfflineReady() {
            console.info('[pwa] app is ready to work offline')
        },

        onRegisteredSW(_swUrl, registration) {
            if (!registration) return

            // Browsers only check for a new SW on navigation by default, which
            // means a tab left open for hours might miss an update. Force a
            // periodic check so long-lived tabs still pick up new builds.
            setInterval(() => {
                registration.update().catch(() => {
                    // Network hiccup or offline — safe to ignore, we'll retry next interval.
                })
            }, HOUR_MS)
        },

        onRegisterError(error) {
            console.error('[pwa] service worker registration failed', error)
        },
    })
}
